import PropTypes from "prop-types";

function SaveToHearts({ onClick, ratingValue }) {
  return (
    <button
      data-test-id="save-to-hearts-button"
      onClick={onClick}
      className={`rounded-3xl px-4 h-11 leading-none capitalize active:opacity-60 flex items-center justify-center gap-2 ${
        ratingValue > 0 ? "text-wine border border-wine" : "bg-wine text-white"
      } w-full`}>
      {ratingValue > 0 ? "Remove from Hearts" : "Save to Hearts"}
    </button>
  );
}

SaveToHearts.propTypes = {
  onClick: PropTypes.func,
  ratingValue: PropTypes.number,
};

export default SaveToHearts;
